export * from './admin.store'
export * from './auth.store'
export * from './notifications.store'
export * from './workspace.store'
export * from './users.store'
export * from './settings.store'
export * from './policy.store'
export * from './policyChat.store'
export * from './policyTracker.store'
export * from './workspaceAssistant.store'
export * from './riskAssessmentCategories.store'
export * from './riskAssessmentTypes.store'
export * from './riskAssessments.store'
export * from './training.store'
export * from './trainingTemplates.store'
export * from './adminTrainingTemplates.store'
export * from './trainingVideos.store'
export * from './trainingGenerate.store'
export * from './trainingGenerateSimple.store'
export * from './questionnaires.store'
export * from './formTemplates.store'
export * from './sharing.store'
export * from './vendors.store'
export * from './employees.store'
export * from './onboardingParties.store'

export * from './reporting.store'
export * from './complianceAlerts.store'
export * from './alerts.store'
export * from './complianceCalendar.store'
export * from './complianceAgent.store'
export * from './loader.store'
export * from './app.store'
export * from './fileManagement.store'
export * from './approvalRequests.store'
export * from './drive.store'
export * from './adminGoogle.store'
export * from './onboarding.store'
export * from './joinRequests.store'
export * from './feedbacks.store'
export * from './documentTemplates.store'
export * from './documentSign.store'
export * from './audits.store'

import { getActivePinia } from 'pinia'
import { queryClient } from '@/plugins/vue-query'

export const resetAllPiniaStores = () => {
  // Server-state cache (TanStack Query) must not outlive the session either.
  queryClient.clear()
  const activeStores = Object.keys(getActivePinia().state.value)

  activeStores.forEach((store) => {
    getActivePinia()._s.get(store).$reset()
  })
}
